import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import Upgrade from 'modules/core/components/Upgrade'
import { UpgradeActions } from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

const UpgradePlan = () => {
  const [showUpgradeModalFlow, setShowUpgradeModalFlow] = React.useState(false)
  const { company } = useCurrentSession()
  const isLegacy = company.subscription.isLegacy ?? false

  return (
    <>
      <Box flexGrow paddingX="s0" paddingBottom="s32" width="full">
        <Upgrade.Small
          title={i18n.t('settings.approvals.approval_rule.upgrade_plan.title')}
          action={{
            type: UpgradeActions.knowMore,
            onClick: () => {
              setShowUpgradeModalFlow(true)
            },
          }}
        />
        {showUpgradeModalFlow && (
          <UpsellingKit.ProductModal
            isOpen={showUpgradeModalFlow}
            onClose={() => setShowUpgradeModalFlow(false)}
            requestSource="Approval flow configuration"
            featureRequested={Features.expenses_auto_approval_rules}
            moduleRequested={AvailableModules.expenses}
            requestReason={
              isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature
            }
            pageSource="approvals_flow"
          />
        )}
      </Box>
    </>
  )
}

export default observer(UpgradePlan)
